import { Adunit as StandaloneAdunit } from '@/components/Adunit';
import { ArticleTeaserDefault as StandaloneArticleTeaserDefault } from '@/components/ArticleTeaser/Default';
import { Row as StandaloneRow } from '@/components/Row';
import { SearchTheme } from '@/components/Search/theme';
import { Spinner as StandaloneSpinner } from '@/components/Spinner';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: SearchTheme });

const Base = $({ as: 'div', slot: 'base' });
const Adunit = GenericSlot({ as: StandaloneAdunit, theme: SearchTheme.Adunit });
const Row = GenericSlot({ as: StandaloneRow, theme: SearchTheme.Row });
const SearchItem = GenericSlot({ as: StandaloneArticleTeaserDefault, theme: SearchTheme.SearchItem });
const Spinner = GenericSlot({ as: StandaloneSpinner, theme: SearchTheme.Spinner });

export default Object.assign(Base, { Adunit, Row, SearchItem, Spinner });
